import { composeIO } from 'react-compose-io'
import { graficoDonutIO } from './GraficoDonut.IO'
import { GraficoDonutView } from './GraficoDonut.View'

export const GraficoDonut = composeIO(GraficoDonutView, graficoDonutIO)
